import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Logout } from '../services/AccountService';
import { withRouter } from 'react-router-dom';
import { showSuccessMessage, showConfirmationMessage, showErrorMessage } from '../utils/Utility';
import { GetAuthentication } from '../services/AccountService';
const initialState = {
	userInfo: null,
};
class SideBar extends Component {
	state = { ...initialState };
	constructor(props) {
		super(props);
		this.onClickLogout = this.onClickLogout.bind(this);
		this.userLogout = this.userLogout.bind(this);
	}
	componentDidMount() {
		// eslint-disable-next-line no-undef
		$('.sidebar-menu').tree();
		let userInfo = GetAuthentication();
		this.setState({ ...this.state, userInfo: userInfo });
	}
	userLogout() {
		const { history } = this.props;
		let authentication = Logout();
		authentication.then(result => {
			if (result) {
				if (history) history.push('/login');
				showSuccessMessage('Logout efetuado com sucesso!');
			} else {
				showErrorMessage('Ocorreu uma falha ao realizar o logout');
			}
		});
	}
	onClickLogout = function() {
		showConfirmationMessage('Deseja realmente sair do sistema?', this.userLogout);
	};
	render(props) {
		return (
			<React.Fragment>
				<aside className="main-sidebar">
					<section className="sidebar">
						<div className="user-panel">
							<div className="pull-left image">
								<img src="../../dist/img/user-icon.jpg" className="img-circle" alt="User Image" />
							</div>
							<div className="pull-left info">
								<p title={this.state.userInfo ? this.state.userInfo.name : ''}>
									{this.state.userInfo
										? this.state.userInfo.name.length > 10
											? this.state.userInfo.name.substr(0, 10) + '...'
											: this.state.userInfo.name
										: ''}
								</p>
								<a href="#">
									<i className="fa fa-circle text-success" /> Online
								</a>
							</div>
						</div>
						<ul className="sidebar-menu" data-widget="tree">
							<li className="header">MENU</li>
							<li>
								<Link to="/home">
									<i className="fa fa-dashboard" /> <span>Dashboard</span>
								</Link>
							</li>
							<li className="treeview">
								<a href="#">
									<i className="fa fa-files-o" />
									<span>Cadastros Básicos</span>
									<span className="pull-right-container">
										<i className="fa fa-angle-left pull-right" />
									</span>
								</a>
								<ul className="treeview-menu">
									<li>
										<Link to="/cadastro/produtos">
											<i className="fa fa-circle-o" /> Produtos
										</Link>
									</li>
									<li>
										<Link to="/cadastro/navios">
											<i className="fa fa-circle-o" /> Navios
										</Link>
									</li>
									<li>
										<Link to="/cadastro/veiculos">
											<i className="fa fa-circle-o" /> Veículos
										</Link>
									</li>
								</ul>
							</li>
							<li className="treeview">
								<a href="#">
									<i className="fa fa-industry" />
									{/* <i className="fa fa-files-o" /> */}
									<span>Operação</span>
									<span className="pull-right-container">
										<i className="fa fa-angle-left pull-right" />
									</span>
								</a>
								<ul className="treeview-menu">
									<li>
										<Link to="/operacao/transportadoras">
											<i className="fa fa-circle-o" /> Transportadora
										</Link>
									</li>
									<li>
										<Link to="/operacao/clientes">
											<i className="fa fa-circle-o" /> Clientes
										</Link>
									</li>
									<li>
										<Link to="/operacao/motoristas">
											<i className="fa fa-circle-o" /> Motoristas
										</Link>
									</li>
									<li>
										<Link to="/operacao/rotas-carregamento">
											<i className="fa fa-circle-o" /> Rotas de Carregamento
										</Link>
									</li>
								</ul>
							</li>
							<li className="treeview">
								<a href="#">
									<i className="fa fa-truck" />
									<span> Lançamentos</span>
									<span className="pull-right-container">
										<i className="fa fa-angle-left pull-right" />
									</span>
								</a>
								<ul className="treeview-menu">
									<li>
										<Link to="/lancamento/nota-carregamento" title="Lançar Nota de Carregamento">
											<i className="fa fa-circle-o" /> Lanc. Notas de Carregamento
										</Link>
									</li>
									<li>
										<Link
											to="/lancamento/cancelar-nota-carregamento"
											title="Cancelar Nota de Carregamento"
										>
											<i className="fa fa-circle-o" /> Canc. Nota de Carregamento
										</Link>
									</li>
								</ul>
							</li>
							<li className="treeview">
								<a href="#">
									<i className="fa fa-key" />
									<span>Segurança</span>
									<span className="pull-right-container">
										<i className="fa fa-angle-left pull-right" />
									</span>
								</a>
								<ul className="treeview-menu">
									<li>
										<Link to="/seguranca/usuarios">
											<i className="fa fa-circle-o" /> Usuários
										</Link>
									</li>
									<li>
										<Link to="/seguranca/acesso-usuarios">
											<i className="fa fa-circle-o" /> Acessos
										</Link>
									</li>
								</ul>
							</li>
							<li>
								<a href="#" onClick={this.onClickLogout}>
									<i className="fa fa-power-off" /> <span>Sair</span>
								</a>
							</li>
							{/* <li className="treeview">
							<a href="#">
								<i className="fa fa-edit" /> <span>Forms</span>
								<span className="pull-right-container">
									<i className="fa fa-angle-left pull-right" />
								</span>
							</a>
							<ul className="treeview-menu">
								<li>
									<a href="../forms/general.html">
										<i className="fa fa-circle-o" /> General Elements
									</a>
								</li>
								<li>
									<a href="../forms/advanced.html">
										<i className="fa fa-circle-o" /> Advanced Elements
									</a>
								</li>
								<li>
									<a href="../forms/editors.html">
										<i className="fa fa-circle-o" /> Editors
									</a>
								</li>
							</ul>
						</li>
						<li className="treeview">
							<a href="#">
								<i className="fa fa-table" /> <span>Tables</span>
								<span className="pull-right-container">
									<i className="fa fa-angle-left pull-right" />
								</span>
							</a>
							<ul className="treeview-menu">
								<li>
									<a href="../tables/simple.html">
										<i className="fa fa-circle-o" /> Simple tables
									</a>
								</li>
								<li>
									<a href="../tables/data.html">
										<i className="fa fa-circle-o" /> Data tables
									</a>
								</li>
							</ul>
						</li>
						<li>
							<a href="../calendar.html">
								<i className="fa fa-calendar" /> <span>Calendar</span>
								<span className="pull-right-container">
									<small className="label pull-right bg-red">3</small>
									<small className="label pull-right bg-blue">17</small>
								</span>
							</a>
						</li>
						<li>
							<a href="../mailbox/mailbox.html">
								<i className="fa fa-envelope" /> <span>Mailbox</span>
								<span className="pull-right-container">
									<small className="label pull-right bg-yellow">12</small>
									<small className="label pull-right bg-green">16</small>
									<small className="label pull-right bg-red">5</small>
								</span>
							</a>
						</li>
						<li className="treeview active">
							<a href="#">
								<i className="fa fa-folder" /> <span>Examples</span>
								<span className="pull-right-container">
									<i className="fa fa-angle-left pull-right" />
								</span>
							</a>
							<ul className="treeview-menu">
								<li>
									<a href="invoice.html">
										<i className="fa fa-circle-o" /> Invoice
									</a>
								</li>
								<li>
									<a href="profile.html">
										<i className="fa fa-circle-o" /> Profile
									</a>
								</li>
								<li>
									<a href="login.html">
										<i className="fa fa-circle-o" /> Login
									</a>
								</li>
								<li>
									<a href="register.html">
										<i className="fa fa-circle-o" /> Register
									</a>
								</li>
								<li>
									<a href="lockscreen.html">
										<i className="fa fa-circle-o" /> Lockscreen
									</a>
								</li>
								<li>
									<a href="404.html">
										<i className="fa fa-circle-o" /> 404 Error
									</a>
								</li>
								<li>
									<a href="500.html">
										<i className="fa fa-circle-o" /> 500 Error
									</a>
								</li>
								<li className="active">
									<a href="blank.html">
										<i className="fa fa-circle-o" /> Blank Page
									</a>
								</li>
								<li>
									<a href="pace.html">
										<i className="fa fa-circle-o" /> Pace Page
									</a>
								</li>
							</ul>
						</li>
						<li className="treeview">
							<a href="#">
								<i className="fa fa-share" /> <span>Multilevel</span>
								<span className="pull-right-container">
									<i className="fa fa-angle-left pull-right" />
								</span>
							</a>
							<ul className="treeview-menu">
								<li>
									<a href="#">
										<i className="fa fa-circle-o" /> Level One
									</a>
								</li>
								<li className="treeview">
									<a href="#">
										<i className="fa fa-circle-o" /> Level One
										<span className="pull-right-container">
											<i className="fa fa-angle-left pull-right" />
										</span>
									</a>
									<ul className="treeview-menu">
										<li>
											<a href="#">
												<i className="fa fa-circle-o" /> Level Two
											</a>
										</li>
										<li className="treeview">
											<a href="#">
												<i className="fa fa-circle-o" /> Level Two
												<span className="pull-right-container">
													<i className="fa fa-angle-left pull-right" />
												</span>
											</a>
											<ul className="treeview-menu">
												<li>
													<a href="#">
														<i className="fa fa-circle-o" /> Level Three
													</a>
												</li>
												<li>
													<a href="#">
														<i className="fa fa-circle-o" /> Level Three
													</a>
												</li>
											</ul>
										</li>
									</ul>
								</li>
								<li>
									<a href="#">
										<i className="fa fa-circle-o" /> Level One
									</a>
								</li>
							</ul>
						</li>
						<li>
							<a href="https://adminlte.io/docs">
								<i className="fa fa-book" /> <span>Documentation</span>
							</a>
						</li>
						<li className="header">LABELS</li>
						<li>
							<a href="#">
								<i className="fa fa-circle-o text-red" /> <span>Important</span>
							</a>
						</li>
						<li>
							<a href="#">
								<i className="fa fa-circle-o text-yellow" /> <span>Warning</span>
							</a>
						</li>
						<li>
							<a href="#">
								<i className="fa fa-circle-o text-aqua" /> <span>Information</span>
							</a>
						</li> */}
						</ul>
					</section>
				</aside>
			</React.Fragment>
		);
	}
}

export default withRouter(SideBar);
